import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { type IArticle } from 'pages/howTo/types/interfaces/IHowTo'
import colors from 'styles/colors'

interface IAccordionItemsProps {
    sectionName: string
    items: IArticle[]
}

export const AccordionItems = ({
    sectionName,
    items
}: IAccordionItemsProps) => {
    const { t } = useTranslation()

    return (
        <>
            {items.map((item: IArticle) => (
                <StyledAccordionItem key={item.id}>
                    <StyledLink
                        to={`/how-to/faq/${item.id}`}
                        state={{ sectionName, title: item.title }}
                    />
                    {t(item.title)}
                </StyledAccordionItem>
            ))}
        </>
    )
}

const StyledAccordionItem = styled.div`
    align-items: center;
    color: ${colors.blueDark};
    display: flex;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.7rem;
    letter-spacing: 0.02em;
    height: 4rem;
    padding: 0 2rem;
    position: relative;
`

const StyledLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`
